var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React, { Component } from 'react';
import { inject } from 'mobx-react';
import cxs from 'cxs/component';
import Theme, { marks, strMark } from 'Theme';
import { t } from 'helpers/i18n';
import History from 'helpers/History';
import { sections } from 'scenes/Main';
import { Button } from 'elements';
import HamburgerMenu from './HamburgerMenu';
import CheeseburgerMenu from './CheeseBurgerMenu';
import theme from 'Theme';
import QueryParams from '../QueryParams';
var NavBarMobile = /** @class */ (function (_super) {
    __extends(NavBarMobile, _super);
    function NavBarMobile(props, context) {
        var _this = this;
        var _a;
        _this = _super.call(this, props, context) || this;
        _this.state = {
            selectedSection: undefined,
            activePath: undefined,
            open: false
        };
        _this.items = [];
        _this.handleSection = function (selectedSection) { return function () {
            _this.setState({ selectedSection: selectedSection });
            if (selectedSection)
                _this.handleLink(selectedSection.links[0].path)();
        }; };
        _this.handleLink = function (activePath) { return function () {
            _this.setState({ activePath: activePath });
            _this.closeMenu();
            History.push(activePath);
        }; };
        _this.handleHamburgerClick = function (event) {
            _this.setState({
                open: !_this.state.open
            });
        };
        _this.closeMenu = function () {
            _this.setState({ open: false });
        };
        var currentPath = (pathRegex.exec(History.location.pathname) || [])[1];
        var isCivitrip = ((_a = _this.props.queryParams) === null || _a === void 0 ? void 0 : _a[strMark]) === marks.civitrip;
        var selectedSection = currentPath
            ? sections(props.store.users.user, isCivitrip).find(function (section) {
                return section.links.find(function (link) { return link.path.indexOf(currentPath) > -1; })
                    ? true
                    : false;
            })
            : undefined;
        _this.state.selectedSection = selectedSection;
        _this.state.activePath = currentPath;
        return _this;
    }
    NavBarMobile.prototype.render = function () {
        var _this = this;
        var _a;
        var selectedSection = this.state.selectedSection;
        var isCivitrip = ((_a = this.props.queryParams) === null || _a === void 0 ? void 0 : _a[strMark]) === marks.civitrip;
        return (React.createElement("div", { style: {
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                height: Theme.size.bar,
                borderTop: "".concat(Theme.size.hairline, " solid ").concat(Theme.color.hairline),
                backgroundColor: Theme.color.background
            } },
            React.createElement(HamburgerMenu, { isOpen: this.state.open, menuClicked: this.handleHamburgerClick }),
            React.createElement(CheeseburgerMenu, { noShadow: true, topOffset: theme.size.bar, isOpen: this.state.open, closeCallback: this.closeMenu },
                React.createElement("div", { style: {
                        display: 'flex',
                        flexDirection: 'column'
                    } }, sections(this.props.store.users.user, isCivitrip).map(function (section) { return (React.createElement(DropDown, { key: section.name },
                    React.createElement(StyledButton, { onClick: function () {
                        } }, t(section.name)),
                    React.createElement(DropDownContent, null, section.links.map(function (link) { return (React.createElement(DropDownLink, { onClick: _this.handleLink(link.path), key: link.name }, t(link.name))); })))); })))));
    };
    NavBarMobile = __decorate([
        inject('store')
    ], NavBarMobile);
    return NavBarMobile;
}(Component));
var DropDown = cxs('div')({
    float: 'left',
    overflow: 'hidden',
    ':hover div': {
        display: 'block'
    },
    ':hover > button': {
        color: Theme.color.primary
    },
    borderBottom: "".concat(Theme.size.hairline, " solid ").concat(Theme.color.hairline),
});
var StyledButton = cxs(Button)({});
var DropDownContent = cxs('div')({
    zIndex: 1002,
    display: 'none',
    position: 'relative',
    backgroundColor: Theme.color.background,
    border: "".concat(Theme.size.hairline, " solid ").concat(Theme.color.hairline),
    /*borderTopWidth: 0,*/
    ':last-child': {
        borderWidth: 0
    },
    /*boxShadow: '0px 3px 5px -1px rgba(0,0,0,0.2)'*/
});
var DropDownLink = cxs(Button)({
    display: 'block',
    width: '100%',
    float: 'none',
    borderBottom: "".concat(Theme.size.hairline, " solid ").concat(Theme.color.hairline),
    ':last-child': {
        borderWidth: 0
    },
    ':hover': {
        color: Theme.color.primary
    }
});
var Wrapper = cxs('div')({
    display: 'flex',
    height: Theme.size.bar,
    borderTop: "".concat(Theme.size.hairline, " solid ").concat(Theme.color.hairline),
    backgroundColor: Theme.color.background
});
/*const StyledButton = cxs(Button)({
  flex: 1
} as CSSProperties)*/
var pathRegex = /\/(\w*)/;
// const pathRegex = /\/.*?\/(\w*)/
var isActive = function (_path) {
    var currentPath = (pathRegex.exec(History.location.pathname) || [])[1];
    var path = (pathRegex.exec(_path) || [])[1];
    return currentPath === path;
};
export default QueryParams(NavBarMobile);



//////////////////
// WEBPACK FOOTER
// ./src/components/NavBarMobile/index.tsx
// module id = 1046
// module chunks = 0